module.exports = isPromise;

function isPromise(obj) {
  return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
}



/*****************
 ** WEBPACK FOOTER
 ** /opt/yplan/npm_env_portal_2/~/redux-form/~/is-promise/index.js
 ** module id = 460
 ** module chunks = 0
 **/